import { useLocation, useNavigate } from 'react-router-dom';
import { authManager, PORTAL_RETURN_PATH_KEY } from '../../../auth/authManager';
import { useEffect, useRef } from 'react';
import { Paths } from '../../common';
import Logo from '../../common/appLogo';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    logo: {
        fontSize: '3rem',
    },
});

export const SigninOidc = () => {
    //Hooks
    const navTo = useNavigate();
    const location = useLocation();
    const tokenExchange = useRef<Promise<void>>();

    //Params
    const queryParams = new URLSearchParams(location.search);
    const authToken = queryParams.get('auth');

    //Styles
    const styles = useStyles();

    useEffect(() => {
        let isDisposed = false;

        const navigateToPortal = (loginError?: string) => {
            const returnPath = sessionStorage.getItem(PORTAL_RETURN_PATH_KEY);
            sessionStorage.removeItem(PORTAL_RETURN_PATH_KEY);
            const isValidCasePath = /^\/[^/?#]+$/.test(returnPath ?? '') && returnPath !== '/signin-oidc';
            navTo(isValidCasePath ? returnPath as string : Paths.index, {
                replace: true,
                ...(authToken === '1' && { state: { loginAttempted: true, loginError } }),
            });
        };

        const completeSignIn = async () => {
            let loginError: string | undefined;
            try {
                if (authToken === '1') {
                    // Strict Mode replays effects; an authorization code can only be exchanged once.
                    tokenExchange.current ??= authManager.getAccessToken();
                    await tokenExchange.current;
                } else {
                    await Promise.resolve();
                }
            } catch (error) {
                console.error('Sign-in token exchange failed', error);
                loginError = 'There was an error logging in. Please try again.';
            }

            if (!isDisposed) {
                navigateToPortal(loginError);
            }
        };

        void completeSignIn();

        return () => {
            isDisposed = true;
        };
    }, [authToken, navTo]);

    return (
        <>
            <Logo className={styles.logo} />
        </>
    );
};
